import { createContext, useContext, ReactNode, useState } from "react"

interface ReorderContextType {
  isReorderOpen: boolean
  setIsReorderOpen: (open: boolean) => void
}

const ReorderContext = createContext<ReorderContextType | undefined>(undefined)

export function ReorderProvider({ children }: { children: ReactNode }) {
  const [isReorderOpen, setIsReorderOpen] = useState(false)

  return (
    <ReorderContext.Provider value={{ isReorderOpen, setIsReorderOpen }}>
      {children}
    </ReorderContext.Provider>
  )
}

export function useReorder() {
  const context = useContext(ReorderContext)
  if (!context) {
    throw new Error(`useReorder must be used within ReorderProvider`)
  }
  return context
}
